export default "__VITE_ASSET__DzTVDoTt__"